import React from "react";
import { useTranslation } from "next-i18next";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import UpdateIcon from "@mui/icons-material/Update";

interface Props {
  onNext: () => void;
}

/**
 * Employee Access Warning step / screen.
 */
export function EmployeeWarningStep({ onNext }: Props) {
  const { t } = useTranslation();

  function handleSubmit(event: React.SyntheticEvent) {
    event.preventDefault();
    onNext();
  }

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Box>
          <Box sx={{}}>
            <Typography
              variant="h1"
              sx={{
                fontSize: "1.75em",
                fontWeight: "bold",
              }}
            >
              {t("request_access:employee_access_warning.title")}
            </Typography>
          </Box>
          <Box sx={{ fontSize: "1em" }}>
            {t("request_access:employee_access_warning.summary")}
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              listStyle: "none",
              padding: "2rem 3rem 2rem 3rem",
              margin: 0,
              gap: 4,
            }}
            component="ul"
          >
            <li>
              <Box
                sx={{
                  display: "flex",
                  gap: 4,
                  alignItems: "center",
                  textAlign: "left",
                }}
              >
                <div>
                  <FileCopyIcon />
                </div>
                <div>{t("request_access:employee_access_warning.item1")}</div>
              </Box>
            </li>
            <li>
              <Box
                sx={{
                  display: "flex",
                  gap: 4,
                  alignItems: "center",
                  textAlign: "left",
                }}
              >
                <div>
                  <CheckBoxIcon />
                </div>
                <div>{t("request_access:employee_access_warning.item2")}</div>
              </Box>
            </li>
            <li>
              <Box
                sx={{
                  display: "flex",
                  gap: 4,
                  alignItems: "center",
                  textAlign: "left",
                }}
              >
                <div>
                  <UpdateIcon />
                </div>
                <div>{t("request_access:employee_access_warning.item3")}</div>
              </Box>
            </li>
          </Box>
          <Box
            sx={{
              backgroundColor: "hsla(0,0%,60%,.2)",
              border: "1.5px solid #999",
              p: 4,
              mb: "28px",
            }}
          >
            <div
              dangerouslySetInnerHTML={{
                __html:
                  t("request_access:employee_access_warning.important") ?? "",
              }}
            ></div>
          </Box>
        </Box>
        <Button sx={{ width: "100%" }} type="submit">
          {t("request_access:employee_access_warning.continue_employee")}
        </Button>
      </form>
    </>
  );
}
